import Api from '../api';
let uri = '/api/ed/rol';

export const getRoles = () => {
    return Api.getInstance().executeGetQuery(uri)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const createRol = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
        .then((resp) => resp)
        .catch((error) =>
            console.log(error)
        );
}


export const editRol = (data) => {
    return Api.getInstance().executeUpdateQuery(uri, data)
        .then(res => res)
        .catch(err => console.log(err));
}

export const getPantallasInicio = () => {
    return Api.getInstance().executeGetQuery(`${uri}/pantallas`)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const getSegmentosAsignados = (data) => {
    return Api.getInstance().executeQuery(`${uri}/segmento`, data)
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}


export const adminRolSegmento = (data) => {
    return Api.getInstance().executeQuery(`${uri}/admin/segmento`, data)
        .then((resp) => resp)
        .catch((error) =>
            console.log(error)
        );
}



